import React from 'react'
import styled from 'styled-components'

const ToggleControl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 0.35rem;
  flex: 1;
`

const ToggleLabel = styled.div`
  font-size: 0.55rem;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.03rem;
  text-align: center;
  line-height: 1.2;
  height: 1.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`

const ToggleSwitch = styled.button<{ $active: boolean; $disabled?: boolean }>`
  width: 36px;
  height: 20px;
  border-radius: 10px;
  border: none;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  position: relative;
  transition: background-color 0.2s ease;
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  background-color: ${({ $active }) =>
    $active ? 'rgba(59, 130, 246, 0.8)' : 'rgba(255, 255, 255, 0.2)'};

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ $active }) => ($active ? '18px' : '2px')};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: white;
    transition: left 0.2s ease;
  }

  &:hover {
    background-color: ${({ $active, $disabled }) =>
      $disabled
        ? $active
          ? 'rgba(59, 130, 246, 0.8)'
          : 'rgba(255, 255, 255, 0.2)'
        : $active
          ? 'rgba(59, 130, 246, 1)'
          : 'rgba(255, 255, 255, 0.3)'};
  }
`

interface PhotoReelToggleProps {
  label: string
  active: boolean
  onToggle: () => void
  disabled?: boolean
}

export const PhotoReelToggle: React.FC<PhotoReelToggleProps> = ({
  label,
  active,
  onToggle,
  disabled = false,
}) => {
  return (
    <ToggleControl>
      <ToggleLabel>{label}</ToggleLabel>
      <ToggleSwitch
        type='button'
        $active={active}
        $disabled={disabled}
        onClick={disabled ? undefined : onToggle}
        disabled={disabled}
      />
    </ToggleControl>
  )
}
